import { dom, library } from '@fortawesome/fontawesome-svg-core'

import {
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowToTop,
  faBan,
  faBullhorn,
  faClipboard,
  faCog,
  faCommentAlt,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExternalLink,
  faHandshake,
  faImage,
  faInfoCircle,
  faLifeRing,
  faLink,
  faLock,
  faLongArrowLeft,
  faMegaphone,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPlaceOfWorship,
  faPlus,
  faPlusCircle,
  faPresentation,
  faQuestionCircle,
  faReply,
  faSearch,
  faSignIn,
  faSync,
  faTimes,
  faTrash,
  faUnlock,
  faUsers,
  faUserSecret,
} from '@fortawesome/pro-light-svg-icons'

import {
  faBold,
  faCheck,
  faExclamationTriangle,
  faExpand,
  faH1,
  faH2,
  faHorizontalRule,
  faImages,
  faItalic,
  faListOl,
  faListUl,
  faQuoteRight,
  faRedo,
  faShieldAlt,
  faStrikethrough,
  faThumbtack,
  faUnderline,
  faUndo,
  faVideo,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faChevronLeft,
  faChevronRight,
  faCircle,
  faPencil as faSolidPencil,
  faThumbtack as faSolidThumbtack,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faFacebookF,
  faLinkedin,
  faTwitter,
  faXing,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowToTop,
  faBan,
  faBold,
  faBullhorn,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClipboard,
  faCog,
  faCommentAlt,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationTriangle,
  faExpand,
  faExternalLink,
  faFacebookF,
  faHandshake,
  faH1,
  faH2,
  faHorizontalRule,
  faImage,
  faImages,
  faInfoCircle,
  faItalic,
  faLifeRing,
  faLink,
  faLinkedin,
  faListOl,
  faListUl,
  faLock,
  faLongArrowLeft,
  faMegaphone,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPlaceOfWorship,
  faPlus,
  faPlusCircle,
  faPresentation,
  faQuestionCircle,
  faQuoteRight,
  faRedo,
  faReply,
  faSearch,
  faShieldAlt,
  faSignIn,
  faSolidPencil,
  faSolidThumbtack,
  faStrikethrough,
  faSync,
  faThumbtack,
  faTimes,
  faTrash,
  faTwitter,
  faUnderline,
  faUndo,
  faUnlock,
  faUsers,
  faUserSecret,
  faVideo,
  faXing,
  faYoutube
)

dom.watch()
